import { QuotationList } from "./QuotationList";
import { QuotationCreate } from "./quotations/QuotationCreate";
import { QuotationEdit } from "./quotations/QuotationEdit";
import { QuotationShow } from "./quotations/QuotationShow";

import { PICreate } from "./proforma-invoices/PICreate";
import { PIEdit } from "./proforma-invoices/PIEdit";
import { PIList } from "./proforma-invoices/PIList";
import { PIShow } from "./proforma-invoices/PIShow";

import { POCreate } from "./purchase-orders/POCreate";
import { POEdit } from "./purchase-orders/POEdit";
import { POList } from "./purchase-orders/POList";
import { POShow } from "./purchase-orders/POShow";

import { InvoiceCreate } from "./invoices/InvoiceCreate";
import { InvoiceEdit } from "./invoices/InvoiceEdit";
import { InvoiceList } from "./invoices/InvoiceList";
import { InvoiceShow } from "./invoices/InvoiceShow";

import { DCCreate } from "./delivery-challans/DCCreate";
import { DCEdit } from "./delivery-challans/DCEdit";
import { DCList } from "./delivery-challans/DCList";
import { DCShow } from "./delivery-challans/DCShow";

import { SalesOrderCreate } from "./sales-orders/SalesOrderCreate";
import { SalesOrderEdit } from "./sales-orders/SalesOrderEdit";
import { SalesOrderList } from "./sales-orders/SalesOrderList";
import { SalesOrderShow } from "./sales-orders/SalesOrderShow";

import { withRBAC } from "../rbac";

export const quotations = {
    list: withRBAC(QuotationList, "view_documents"),
    create: withRBAC(QuotationCreate, "manage_documents"),
    edit: withRBAC(QuotationEdit, "manage_documents"),
    show: withRBAC(QuotationShow, "view_documents"),
};

export const proforma_invoices = {
    list: withRBAC(PIList, "view_documents"),
    create: withRBAC(PICreate, "manage_documents"),
    edit: withRBAC(PIEdit, "manage_documents"),
    show: withRBAC(PIShow, "view_documents"),
};

export const purchase_orders = {
    list: withRBAC(POList, "view_documents"),
    create: withRBAC(POCreate, "manage_documents"),
    edit: withRBAC(POEdit, "manage_documents"),
    show: withRBAC(POShow, "view_documents"),
};

export const invoices = {
    list: withRBAC(InvoiceList, "view_documents"),
    create: withRBAC(InvoiceCreate, "manage_documents"),
    edit: withRBAC(InvoiceEdit, "manage_documents"),
    show: withRBAC(InvoiceShow, "view_documents"),
};

export const delivery_challans = {
    list: withRBAC(DCList, "view_documents"),
    create: withRBAC(DCCreate, "manage_documents"),
    edit: withRBAC(DCEdit, "manage_documents"),
    show: withRBAC(DCShow, "view_documents"),
};

export const sales_orders = {
    list: withRBAC(SalesOrderList, "view_documents"),
    create: withRBAC(SalesOrderCreate, "manage_documents"),
    edit: withRBAC(SalesOrderEdit, "manage_documents"),
    show: withRBAC(SalesOrderShow, "view_documents"),
};
